/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedSplatRouteImport } from './routes/_authed/$'
import { Route as AuthedAmpProjectsRouteImport } from './routes/_authed/amp-projects'
import { Route as AuthedStaffRouteImport } from './routes/_authed/staff'
import { Route as AuthedCliAuthorizeRouteImport } from './routes/_authed/cli.authorize'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSplatRoute = AuthedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAmpProjectsRoute = AuthedAmpProjectsRouteImport.update({
  id: '/amp-projects',
  path: '/amp-projects',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStaffRoute = AuthedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCliAuthorizeRoute = AuthedCliAuthorizeRouteImport.update({
  id: '/cli/authorize',
  path: '/cli/authorize',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/$': typeof AuthedSplatRoute
  '/amp-projects': typeof AuthedAmpProjectsRoute
  '/staff': typeof AuthedStaffRoute
  '/cli/authorize': typeof AuthedCliAuthorizeRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/$': typeof AuthedSplatRoute
  '/amp-projects': typeof AuthedAmpProjectsRoute
  '/staff': typeof AuthedStaffRoute
  '/': typeof AuthedIndexRoute
  '/cli/authorize': typeof AuthedCliAuthorizeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/_authed/$': typeof AuthedSplatRoute
  '/_authed/amp-projects': typeof AuthedAmpProjectsRoute
  '/_authed/staff': typeof AuthedStaffRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/cli/authorize': typeof AuthedCliAuthorizeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/$'
    | '/amp-projects'
    | '/staff'
    | '/cli/authorize'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/$'
    | '/amp-projects'
    | '/staff'
    | '/'
    | '/cli/authorize'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/logout'
    | '/_authed/$'
    | '/_authed/amp-projects'
    | '/_authed/staff'
    | '/_authed/'
    | '/_authed/cli/authorize'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/$': {
      id: '/_authed/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthedSplatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/amp-projects': {
      id: '/_authed/amp-projects'
      path: '/amp-projects'
      fullPath: '/amp-projects'
      preLoaderRoute: typeof AuthedAmpProjectsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/staff': {
      id: '/_authed/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthedStaffRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cli/authorize': {
      id: '/_authed/cli/authorize'
      path: '/cli/authorize'
      fullPath: '/cli/authorize'
      preLoaderRoute: typeof AuthedCliAuthorizeRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedSplatRoute: typeof AuthedSplatRoute
  AuthedAmpProjectsRoute: typeof AuthedAmpProjectsRoute
  AuthedStaffRoute: typeof AuthedStaffRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedCliAuthorizeRoute: typeof AuthedCliAuthorizeRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSplatRoute: AuthedSplatRoute,
  AuthedAmpProjectsRoute: AuthedAmpProjectsRoute,
  AuthedStaffRoute: AuthedStaffRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedCliAuthorizeRoute: AuthedCliAuthorizeRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
